import { createAction } from "@reduxjs/toolkit";
import { DamStatus } from "src/types/damStatus";

export const DAM_STATUSES_GET_ALL = createAction<{ damStatuses: DamStatus[] }>("@damStatuses/GET_ALL");
export const DAM_STATUSES_GET_BY_ID = createAction<{ damStatus: DamStatus }>("@damStatuses/GET_BY_ID");
export const DAM_STATUSES_ADD = createAction<{ damStatus: DamStatus }>("@damStatuses/ADD");
export const DAM_STATUSES_UPDATE = createAction<{ damStatus: DamStatus }>("@damStatuses/UPDATE");
export const DAM_STATUSES_DELETE = createAction<{ damStatusId: string }>("@damStatuses/DELETE");
